import React from "react";
import "./career.css";

export default function Career() {
  const openings = [
    {
      Date: "Jan 28, 2022",
      role: "Flutter Developer",
      jobDescription:
        "We are looking for an experienced developer to join our team.",
      formUrl: "/jobs/flutter-development",
    },
    {
      Date: "Feb 2, 2022",
      role: "React Developer",
      jobDescription:
        "We are looking for an experienced developer to join our team.",
      formUrl: "/jobs/react-development",
    },
    {
      Date: "Feb 1, 2022",
      role: "Business Development (Sales) and Marketing",
      jobDescription: "We are looking for an full time intern who can",
      formUrl: "/jobs/sales&marketing",
    },
  ];

  return (
    <section id="career" className="scrobits__career-container section__margin">
      <div className="scrobit__career-heading__container">
        <h1 className="gradient__text">Join Us !</h1>
        <p>
          We'll be delighted to assist you in discovering and pursuing your
          passions.
          {/* <br /> and do what they love. */}
        </p>
      </div>
      <div className="scrobit__career-openings__section">
        {openings.map((job, idx) => (
          <Job job={job} key={idx} />
        ))}
      </div>
    </section>
  );
}

const Job = ({ job }) => {
  const { Date, role, jobDescription, formUrl } = job;
  return (
    <article className="scrobit__job-openings__container">
      <div
        className="scrobits__job-openings__information"
        data-aos="fade-up"
        data-aos-duration="3000"
      >
        <code>{Date}</code>
        <h3>{role}</h3>
        <p>{jobDescription}</p>
      </div>
      <div className="job__apply-Link">
        <a href={formUrl}>Apply</a>
      </div>
    </article>
  );
};
